"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_COPY_PERCENTAGE = void 0;
var MAX_COPY_PERCENTAGE = exports.MAX_COPY_PERCENTAGE = 15;